<template>
  <v-row
    no-gutters
    align="center"
    class="fixture"
    :style="cssVars"
  >
    <v-col
      cols="12"
      class="text-right"
    >
      <v-tooltip
        location="top"
        color="background"
        :text="homeTeam?.name"
      >
        <template #activator="{ props }">
          <v-img
            :src="homeTeam?.pictureUrl ?? clubDefaultLogo"
            :width="imageSize"
            :height="imageSize"
            class="d-inline-block vertical-align-middle"
            v-bind="props"
          />
        </template>
      </v-tooltip>
    </v-col>

    <v-col
      cols="12"
      class="text-center"
    >
      <span>vs</span>
    </v-col>

    <v-col
      cols="12"
      class="text-left"
    >
      <v-tooltip
        location="top"
        color="background"
        :text="awayTeam?.name"
      >
        <template #activator="{ props }">
          <v-img
            :src="awayTeam?.pictureUrl ?? clubDefaultLogo"
            :width="imageSize"
            :height="imageSize"
            class="d-inline-block vertical-align-middle"
            v-bind="props"
          />
        </template>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import Team from '@/models/Team/team';
import clubDefaultLogo from '@/assets/club-default-logo.png';

export default {
  name: 'Fixture',
  data() {
    return {
      clubDefaultLogo,
    };
  },
  props: {
    awayTeam: {
      type: Team,
      required: true,
    },
    homeTeam: {
      type: Team,
      required: true,
    },
    cardHeight: {
      type: Number,
      default: 243,
    },
  },
  computed: {
    imageSize() {
      return this.cardHeight / 8.1;
    },
    cssVars() {
      return {
        '--min-height': `${this.cardHeight / 2}px`,
        '--top': `${(this.cardHeight / 4)}px`,
        '--left': `${-((this.imageSize + 6) / 2) - 2}px`,
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fixture {
  background-color: $secondary;
  border-radius: 6px;
  padding: 3px;
  position: absolute;
  flex-direction: column;
  justify-content: space-evenly;
  min-height: var(--min-height);
  top: var(--top);
  left: var(--left);
}

.fixture span {
  font-size: 12px;
  color: black;
}
</style>
